// src/hooks/jobVouchers/useExportJobVoucherPdf.js
import { useMutation } from "@tanstack/react-query";
import { exportJobVoucherToPdf } from "../../api/apiJobVouchers";
import toast from "react-hot-toast";

const useExportJobVoucherPdf = () => {
    const { mutate: exportJobVoucherPdfMutate, isPending, mutateAsync } = useMutation({
        mutationFn: ({ jobVoucherId, html, filename, format = "A4", landscape = false }) => {
            return exportJobVoucherToPdf(jobVoucherId, { html, filename, format, landscape });
        },
        onSuccess: (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                response.headers["content-disposition"]?.split("filename=")[1]?.replace(/"/g, "") || "Voucher.pdf"
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        },
        onError: (error) => {
            const message = error.response?.data?.message || "حدث خطأ أثناء تصدير الفاوتشر";
            toast.error(message);
        },
    });

    return { exportJobVoucherPdfMutate, mutateAsync, isPending };
};

export default useExportJobVoucherPdf;

